import React, { Component, useEffect, useState } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import Slider from "@material-ui/core/Slider";
import Box from "@material-ui/core/Box";
import "./slider.css"

import {
	withStyles
} from "@material-ui/core";

import { slider as styles } from "./styles";

function SliderFilter({ classes, min, max, name, onChange, defaultValue }) {
	const marks = [
		{
			value: -1,
			label: valuetext(-1)
		},
		{
			value: 0,
			label: valuetext(0)
		},{
			value: 1,
			label: valuetext(1)
		},{
			value: 2,
			label: valuetext(2)
		},{
			value: 3,
			label: valuetext(3)
		},
		{
			value: 4,
			label: valuetext(4)
		}
		,
		{
			value: 5,
			label: valuetext(5)
		}
		,
		{
			value: 6,
			label: valuetext(6)
		}
	];


	function valuetext(value) {
		if (value === 6) {
			return "TOUS";
		}
		if( value === 0)
		{
			return "RDC"
		}
		if( value < 0){
			return `R  ${value}`;
		}
		return `R + ${value}`;
	}
	function preventHorizontalKeyboardNavigation(event) {
		if (event.key === "ArrowLeft" || event.key === "ArrowRight") {
			event.preventDefault();
		}
	}


	return (
		<Slider
			classes={{
				vertical: classes.customVertical,
				root: classes.customRoot,
				thumb: classes.customThumb,
				track: classes.customTrack,
				rail: classes.customRail,
				mark: classes.customMarks,
				markLabel: classes.customLabel
			}}
			sx={{
				'& input[type="range"]': {
					WebkitAppearance: "slider-vertical"
				}
			}}

			defaultValue={defaultValue}
			name={name}
			//  valueLabelDisplay="auto"
			// getAriaValueText={valuetext}
			// valueLabelFormat={valuetext}
			marks={marks}
			min={min}
			max={max}
			step={null}
			onChange={onChange}
			orientation={"vertical"}
			onKeyDown={preventHorizontalKeyboardNavigation}
		/>
	);
}

SliderFilter.propTypes = {
	classes: PropTypes.object.isRequired,
	max: PropTypes.number.isRequired,
	min: PropTypes.number.isRequired,
	name: PropTypes.string.isRequired,
	onChange: PropTypes.func.isRequired
};

export default withStyles(styles)(SliderFilter);
